module.exports = __webpack_public_path__ + "img/logout-icon.55cdb828.svg";